/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, Inject, forwardRef } from '@angular/core';
import { DataTable } from './table';


@Component({
    selector: 'data-table-header',
    templateUrl: './header.html',
    styleUrls: ['./header.css'],
    host: {
        '(document:click)': '_closeSelector()'
    },
    standalone: false
})
export class DataTableHeader {

    columnSelectorOpen = false;

    _closeSelector() {
        this.columnSelectorOpen = false;
    }

    constructor(@Inject(forwardRef(() => DataTable)) public dataTable: DataTable) {}
}
